import { AiAccessState } from '@/features/AiChat/model/context/types.ts';
import { useAuthStore } from '@/features/Auth';
import { useUserProfileApi } from '@/features/Profile/model/useUserProfileApi';

export const useAiAccess = (): AiAccessState => {
  const tokenData = useAuthStore((state) => state.tokenData);
  const {
    data: userProfile,
    isLoading: isLoadingUserProfile
  } = useUserProfileApi();
  const hasOrganization = Boolean(tokenData?.org_id?.trim());
  const isAiAccessLoading = Boolean(tokenData?.user_id) && isLoadingUserProfile;
  const isEmailVerified = userProfile?.email_verified === true;
  const canUseAi = hasOrganization && isEmailVerified;

  return {
    canUseAi,
    hasOrganization,
    isAiAccessLoading,
    isEmailVerified,
    tokenData,
    userProfile
  };
};